import jwt from 'jwt-decode';

interface DecodedToken {
  sub: string;
  exp: number;
}

export const getTokenData = (token: string) => {
  const decodedToken = jwt(token) as DecodedToken;
  const username: string = decodedToken.sub;
  const exp: number = decodedToken.exp;

  return { username, exp };
};
